import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { LetterNewBadgeComponent } from './letter-new-badge.component';

@NgModule({
  declarations: [LetterNewBadgeComponent],
  imports: [
    CommonModule
  ],
  exports: [LetterNewBadgeComponent],
})
export class LetterNewBadgeModule { }
